import { parseRowByColumn } from "components/collections/util/datatypes";

const RowCallbaks = ({
  _columns,
  _rows,
  _pageSize,
	_totalPages,
	cacheRef,
	selectedCell,
  isReadOnly,
	showAdd, 
	showDelete,
	showForm,
	checkValidation,
  setRows,
  setSelectedCell,
	onClickDeleteRow,
	onClickDeleteMultipleRows,
  pushRowOperation,
  _updatePage
}) => {

  const _onAddRow = (data = {}) => {

		if(isReadOnly && !showAdd) return;
		if(!showAdd && !showForm) return;

		let newRow = { data };
		newRow.data = parseRowByColumn(newRow.data, _columns);
		setSelectedCell({ ...selectedCell, row: _rows.length });

		let newRows = [..._rows, newRow];
		if(newRows.length > _pageSize) {
			setSelectedCell({ ...selectedCell, row: 0 });
			_updatePage(_totalPages);
		}

		setRows(newRows);
		pushRowOperation([{ final: newRow, action: "create" }]);

	}

	const _onClickDeleteRow = (index) => {

		if(isReadOnly && !showDelete) return;

		if(!checkValidation) {
			const newRows = [..._rows];
			newRows.splice(index, 1);
			setRows(newRows);
		}

		onClickDeleteRow(index);

	}

	const _onClickDeleteMultipleRows = (rows) => {
		
		if(isReadOnly && !showDelete) return;

		if(!checkValidation) {
			const newRows = [..._rows];
			rows.forEach((row) => {
				const index = newRows.findIndex((r) => r.id == row.id);
				if (index !== -1) {
					newRows.splice(index, 1);
				}
			});
			setRows(newRows);
		}

		onClickDeleteMultipleRows(rows.map((row) => row.id));

	}

	const _onClickInsertRow = (index) => {

		if (isReadOnly) return;

		const newRows = [..._rows];
		const newRow = { data: {} };
		_columns.forEach(column => newRow.data[column.name] = null);
		newRows.splice(index, 0, newRow);

		setRows(newRows);
		setSelectedCell(null);
		document.activeElement.blur();
		
		pushRowOperation([{
			aux: _rows[index],
			final: newRow,
			action: "insert"
		}]);

	}

	const _onClickCloneRow = (index) => {

		if (isReadOnly) return;

		const newRows = [..._rows];
		const newRow = { data: { ..._rows[index].data } };
		newRows.splice(index, 0, newRow);

		setRows(newRows);
		setSelectedCell(null);
		document.activeElement.blur();
		
		pushRowOperation([{
			aux: _rows[index],
			final: newRow,
			action: "insert"
		}]);

	}

	const _onChangeRow = (index, name, value, row) => {

		if (isReadOnly) return;

		const newRows = Object.assign([], _rows);
		newRows[index].data = { ...newRows[parseInt(index)].data, [name]: value };

		pushRowOperation([
			{
				initial: row,
				final: newRows[parseInt(index)],
				action: "update",
			}
		]);

		setRows(newRows);

	}

  return {
    _onAddRow,
		_onClickDeleteRow,
		_onClickDeleteMultipleRows,
		_onClickInsertRow,
		_onClickCloneRow,
		_onChangeRow
  }

}

export default RowCallbaks;